import { render, staticRenderFns } from "./UserStatInfo.vue?vue&type=template&id=6bf03064"
import script from "./UserStatInfo.vue?vue&type=script&lang=js"
export * from "./UserStatInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports